import Vue from 'vue'
import App from './App.vue'
import {mainObj} from '@/mixins/main.js'
const {router,store,i18n} = mainObj
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')